import style from './style.module.css'
import React from 'react'
import { Button } from '@crossfit/ui'
const APPLICATION_URL = import.meta.env.VITE_AFFILIATE_APPLICATION_URL

export default function ApplicationWithdrawn(props: { rawStatus: string }) {
  return (
    <div className={style.wrapper}>
      <div className={style.wrapperItem1}>
        <div className={style.iconContainer}>
          <svg className={style.icon} />
        </div>
      </div>
      <div className={style.wrapperItem2}>
        <p className={style.header}>Application {props.rawStatus}</p>
      </div>
      <div className={style.wrapperItem3}>
        <div className={style.buttonContainer}>
          <Button
            variant='primary'
            className={style.button}
            onClick={() => {
              location.href = APPLICATION_URL
            }}
          >
            RESTART APPLICATION
          </Button>
        </div>
      </div>
      <div className={style.wrapperItem4}>
        <div className={style.subHeaderContainer}>
          <p className={style.subHeader}>
            Your application has been {props.rawStatus}. Reach out to
            <a
              href='mailto:affiliatesupport@crossfit.com'
              className={style.subHeaderLink}
            >
              affiliatesupport@crossfit.com
            </a>{' '}
            for additional info.
          </p>
        </div>
      </div>
    </div>
  )
}
